import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsideComponent } from './aside/aside.component';
import { HeaderComponent } from './header/header.component';
import { SecureComponent } from './secure/secure.component';
import { PublicComponent } from './public/public.component';
import { AuthModule } from '../pages/auth/auth.module';
import { PagesModule } from '../pages/pages.module';
import { RouterModule } from '@angular/router';
import { PartialsModule } from '../partials/partials.module';
import {NgxPaginationModule} from 'ngx-pagination';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';

// import { MatIcon, MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    AsideComponent,
    HeaderComponent,
    SecureComponent,
    PublicComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PagesModule,
    AuthModule,
    PartialsModule,
    NgxPaginationModule,
    MatExpansionModule,
    MatSidenavModule,
    AngularSvgIconModule.forRoot(),
    
  ],
  exports:[
    AsideComponent, HeaderComponent,PublicComponent,SecureComponent
  ]
})
export class ThemeModule { }
